import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import AlumnosDistribucionContent from './components/AlumnosDistribucionContent';

const AlumnosDistribucionListado = () => {

    return (
        <>

            <TemplateDashboard>
                <AlumnosDistribucionContent />
            </TemplateDashboard>

        </>
    )
};

export default AlumnosDistribucionListado;